import { render, staticRenderFns } from "./orderResult.vue?vue&type=template&id=1e05c1a5"
import script from "./orderResult.vue?vue&type=script&lang=js"
export * from "./orderResult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports